/* eslint-disable max-len */
import classNames from 'classnames';
import React from 'react';

export const GenreSortGridIcon = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => {
  return (
    <i className={classNames('bookriver-icon-GenreSortGridIcon', className)} {...props} />
  );
};
